exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".info-tooltip{display:inline-block;max-width:18px}.info-tooltip .icon-error{background-color:red;color:#fff;margin-right:0;margin-bottom:0}.pre-wrapper{white-space:pre-wrap}", ""]);

